// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3ugMS","footer":"ModalError_footer__1jouZ"};